import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: "img[errorSrc]",
    standalone: false
})

export class ErrorSrcDirective {

  @Input() errorSrc: string;
  private triedFallback = false;

  constructor(private eRef: ElementRef) {}

  @HostListener("error")

  private onError() {
    if (this.triedFallback) {
      return;
    }
    this.triedFallback = true;
    const element: HTMLImageElement = <HTMLImageElement>this.eRef.nativeElement;
    element.src = this.errorSrc;
  }
}
